"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dialog = _interopRequireDefault(require("britive-design-system/core/components/dialog"));

var _radio = _interopRequireDefault(require("britive-design-system/core/components/radio"));

var _spinner = _interopRequireDefault(require("britive-design-system/core/components/spinner"));

var _textarea = _interopRequireDefault(require("britive-design-system/core/components/textarea"));

var _textfield = _interopRequireDefault(require("britive-design-system/core/components/textfield"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _commonConstants = require("../../../../../utils/common-constants");

var _constants = require("./constants");

var _IncludeHierarchy = _interopRequireDefault(require("./IncludeHierarchy"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.policy-general-tab-main-container {\n  flex-grow: 1;\n  padding-top: 3rem;\n  padding-left: 3.5rem;\n  padding-bottom: 3rem;\n  padding-right: 2rem;\n  overflow: auto; }\n  .policy-general-tab-main-container::-webkit-scrollbar {\n    width: 0.5rem;\n    height: 0.5rem; }\n  .policy-general-tab-main-container::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n    margin-top: 0.125rem; }\n  .policy-general-tab-main-container::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n    background-color: #c6c6c6; }\n  .policy-general-tab-main-container::-webkit-scrollbar-thumb:hover {\n    background-color: #6f6f6f; }\n  .policy-general-tab-main-container .sm-form-name-loader-wrapper {\n    display: flex;\n    align-items: center; }\n    .policy-general-tab-main-container .sm-form-name-loader-wrapper .sm-form-name-check-loader {\n      margin-top: 1.25rem;\n      margin-left: 0.625rem; }\n  .policy-general-tab-main-container .sm-add-policy-field-wrapper {\n    margin-bottom: 2rem; }\n  .policy-general-tab-main-container .sm-add-policy-field-value-wrapper {\n    margin-top: 0.5rem; }\n  .policy-general-tab-main-container .sm-value-wrapper {\n    margin-top: 0.625rem; }\n";
  var fileName = "compone_AddGeneral";
  var element = document.querySelector("style[data-sass-component='compone_AddGeneral']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var General = function General(_ref) {
  var validationHook = _ref.validationHook,
      policyFilterLoading = _ref.policyFilterLoading,
      isEditMode = _ref.isEditMode,
      hideIncludeBelowHierarchyOption = _ref.hideIncludeBelowHierarchyOption,
      translatedStrings = _ref.translatedStrings,
      isSMPolicy = _ref.isSMPolicy,
      consumer = _ref.consumer;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showDenyDialog = _useState2[0],
      setShowDenyDialog = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      changedToDeny = _useState4[0],
      setChangeToDeny = _useState4[1];

  (0, _react.useEffect)(function () {
    consumer === _commonConstants.papServiceConsumer && validationHook.handleChange(validationHook.names.allowDeny, _commonConstants.ALLOW);
  }, []);
  (0, _react.useEffect)(function () {
    changedToDeny && setShowDenyDialog(validationHook.values.allowDeny === _commonConstants.DENY);
  }, [validationHook.values.allowDeny, changedToDeny]);
  var allowOptions = [{
    label: translatedStrings.allow,
    value: 'Allow'
  }, {
    label: translatedStrings.deny,
    value: 'Deny'
  }];
  var includeHierarchyOptions = [{
    label: translatedStrings.yesLabel,
    value: true
  }, {
    label: translatedStrings.noLabel,
    value: false
  }];
  var nameProps = {
    width: '512px',
    label: translatedStrings.policyNameLabel,
    value: validationHook.values.name,
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.name);
    },
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.name, e.target.value);
    },
    error: validationHook.touched.name && Boolean(validationHook.errors.name),
    errorMsg: validationHook.errors.name
  };
  var descriptionProps = {
    width: '512px',
    height: '70px',
    label: translatedStrings.description,
    helperText: translatedStrings.descriptionHelperLabel,
    value: validationHook.values.description,
    onBlur: function onBlur() {
      return validationHook.handleBlur(validationHook.names.description);
    },
    onChange: function onChange(e) {
      return validationHook.handleChange(validationHook.names.description, e.target.value);
    },
    error: validationHook.touched.description && Boolean(validationHook.errors.description),
    errorMsg: validationHook.errors.description
  };
  var accessTypeProps = {
    defaultValue: validationHook.values.allowDeny,
    label: translatedStrings.accessType,
    name: 'access-type',
    direction: 'vertical',
    onChange: function onChange(e) {
      if (e.target.value === _commonConstants.DENY) {
        setChangeToDeny(true);
      }

      validationHook.handleChange(validationHook.names.allowDeny, e.target.value);
    },
    options: allowOptions
  };
  var includeHierarchyProps = {
    defaultValue: validationHook.values.includeHierarchy,
    label: translatedStrings.includeHierarchyBelowPath,
    name: 'resource-type',
    direction: 'vertical',
    onChange: function onChange(e) {
      var _validationHook$value;

      var isIncludeHierarchy = e.target.value === true;
      validationHook.handleChange(validationHook.names.includeHierarchy, isIncludeHierarchy);
      var newResource;

      if (isIncludeHierarchy) {
        if (!(validationHook.values.resource || '').includes(_constants.rootNodePath)) {
          newResource = validationHook.values.resource.concat(_constants.rootNodePath);
          validationHook.handleChange(validationHook.names.resource, validationHook.values.resource.concat(_constants.rootNodePath));
        }
      } else {
        newResource = validationHook.values.resource.replace(_constants.rootNodePath, '');
        validationHook.handleChange(validationHook.names.resource, validationHook.values.resource.replace(_constants.rootNodePath, ''));
      }

      validationHook.handleChange(validationHook.names.permissions, (_validationHook$value = validationHook.values.permissions) === null || _validationHook$value === void 0 ? void 0 : _validationHook$value.map(function (permission) {
        return _objectSpread(_objectSpread({}, permission), {}, {
          resources: newResource
        });
      }));
    },
    options: includeHierarchyOptions,
    includeHierarchy: validationHook.values.includeHierarchy,
    resource: validationHook.values.resource,
    classes: _constants.classes,
    translatedStrings: translatedStrings
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.stepperMainContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.formNameLoaderWrapper
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, nameProps), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.formNameCheckLoader
  }, policyFilterLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "small"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_textarea.default, descriptionProps)), consumer !== _commonConstants.papServiceConsumer && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !isEditMode && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_radio.default, accessTypeProps)), isEditMode && /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, translatedStrings.accessType), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, validationHook.values.allowDeny))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, translatedStrings.resource), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.addPolicyFieldValueWrapper
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, validationHook.values.resource))), isSMPolicy && !isEditMode && !hideIncludeBelowHierarchyOption && /*#__PURE__*/_react.default.createElement(_IncludeHierarchy.default, includeHierarchyProps), showDenyDialog && /*#__PURE__*/_react.default.createElement(_dialog.default, {
    type: "alert",
    width: 700,
    title: translatedStrings.removeApprovalsTitle,
    message: translatedStrings.removeApprovalsMessage,
    primaryButtonText: translatedStrings.yesRemoveApprovals,
    secondaryButtonText: translatedStrings.noLabel,
    onSubmit: function onSubmit() {
      var _validationHook$names = validationHook.names,
          isApprovals = _validationHook$names.isApprovals,
          notificationMedium = _validationHook$names.notificationMedium,
          channelList = _validationHook$names.channelList,
          isChannelsRequired = _validationHook$names.isChannelsRequired,
          tagList = _validationHook$names.tagList,
          userList = _validationHook$names.userList,
          approvalMaxTime = _validationHook$names.approvalMaxTime,
          validFor = _validationHook$names.validFor,
          allowDeny = _validationHook$names.allowDeny;
      validationHook.handleChange(allowDeny, _commonConstants.DENY);
      validationHook.handleChange(isApprovals, false);
      validationHook.handleChange(notificationMedium, '');
      validationHook.handleChange(tagList, []);
      validationHook.handleChange(userList, []);
      validationHook.handleChange(isChannelsRequired, false);
      validationHook.handleChange(channelList, '');
      validationHook.handleChange(approvalMaxTime, '');
      validationHook.handleChange(validFor, '');
      setShowDenyDialog(false);
    },
    onCancel: function onCancel() {
      validationHook.handleChange(validationHook.names.allowDeny, _commonConstants.ALLOW);
      setShowDenyDialog(false);
    }
  })));
};

General.propTypes = {
  policyFilterLoading: _propTypes.default.bool,
  validationHook: _propTypes.default.object,
  isEditMode: _propTypes.default.bool,
  hideIncludeBelowHierarchyOption: _propTypes.default.bool,
  translatedStrings: _propTypes.default.object,
  isSMPolicy: _propTypes.default.bool,
  consumer: _propTypes.default.string
};
var _default = General;
exports.default = _default;